module.exports = __webpack_public_path__ + "img/CV.d8a5ab8b.svg";